import { render } from "./TimelineItem.vue?vue&type=template&id=c798d31a&scoped=true"
import script from "./TimelineItem.vue?vue&type=script&lang=js"
export * from "./TimelineItem.vue?vue&type=script&lang=js"

import "./TimelineItem.vue?vue&type=style&index=0&id=c798d31a&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c798d31a"]])

export default __exports__